import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  getAdminStores,
  GetAdminStoresParams,
  getRegionsStoreCount,
  getStoreAuthErrorCount,
} from 'services/api/admin';
import { getUserStoreCount } from 'services/api/store';

export const stores = createQueryKeys('stores', {
  regionsStoreCount: (permId?: General.PermissionId) => ({
    queryKey: [permId],
    queryFn: ({ signal }) => getRegionsStoreCount(permId, signal),
  }),
  stores: (params: GetAdminStoresParams) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getAdminStores(params, signal),
  }),
  authErrorCount: (orgId: number) => ({
    queryKey: [orgId],
    queryFn: ({ signal }) => getStoreAuthErrorCount(orgId, signal),
  }),
  userStoreCount: {
    queryKey: null,
    queryFn: ({ signal }) => getUserStoreCount(signal),
  },
});
